import { CREATE_CUSTOMER_ACCOUNT } from './create';

export const customerAccountApi = {
  create: CREATE_CUSTOMER_ACCOUNT,
};
